module.exports = __webpack_public_path__ + "img/icon_other.40aec0ef.png";